import { Button, Modal, Col, Container, Row, Form } from "react-bootstrap";
import React, { useEffect, useState } from "react";
import { AlertaModel } from '../models/alert.model';
import { ModalAlertDetail } from './ModalAlertDetail';
import { useTranslation } from 'react-i18next';

import storageService from "../services/storage.service";

import _ from 'lodash';

export const ModalAlertList = (props: any) => {

  const user = storageService.getUser();
  const { t } = useTranslation();
  const [idAlert, setIdAlert] = useState(null);


  const [modalDetail, setModalDetail] = useState(false);

  const openDetail = async (idAlerta) => {
    setIdAlert(idAlerta);
    setModalDetail(true)
  }
  const handleCloseModalDetail = () => {
    setModalDetail(false);
  }

  return (
    <>
      <Modal as={Modal.Dialog} centered show={props.Show} onHide={props.HandleClose} size="lg">
        <Modal.Header>
          <Modal.Title className='h6'>{props.Title}</Modal.Title>
          <Button variant='close' aria-label='Close' onClick={props.HandleClose} />
        </Modal.Header>
        <Modal.Body>
          <Container>
            <Row md={12}
              style={{
                border: 'none',
                background: '#0039A6',
                color: 'white',
                fontWeight: 600,
                textAlign: 'left',
                marginBottom: 1,
                paddingTop: 5,
                paddingBottom: 5

              }} >
              <Col md={7}>{t('MODULE_ALERT.GRID_ALERT_TYPE_ALERT')}</Col>
              <Col md={2}>{t('MODULE_ALERT.GRID_ALERT_QUANTITY')}</Col>
              <Col md={2}></Col>
            </Row>

            {props.ListAlert?.map(item => {
              return <>

                <Row md={12}
                  style={{
                    border: '1px solid rgb(222 226 230)',
                    borderCollapse: 'collapse',
                    paddingTop: 5,
                    marginTop: -1
                  }}
                >
                  <Col md={8}>{t(item.alert_id)}</Col>
                  <Col md={2}>{item.qtd_alert}</Col>
                  <Col md={2}>
                    <Button
                      variant='primary'
                      size="sm"
                      style={{ marginBottom: 5, float: "right" }}
                      onClick={() => { openDetail(item.alert_id) }}>
                      {t('OPEN')}
                    </Button>
                  </Col>
                </Row>
              </>
            })}

          </Container>
        </Modal.Body>
        <Modal.Footer>

          <Button variant="primary" onClick={props.HandleClose}>{props.ButtonCloseLabel}</Button>
        </Modal.Footer>
      </Modal>
      {modalDetail &&
        <ModalAlertDetail
          Title={t('MODULE_ALERT.DETAIL')}
          AlertId={idAlert}
          ButtonCloseLabel={`${t('MODULE_ALERT.CLOSE')}`}
          HandleClose={handleCloseModalDetail}
          Show={modalDetail}>
        </ModalAlertDetail>
      }
    </>
  );
};
